$shm_wordstat_task_catalog $mol_page
	task_id? \
	filter? \
	title \Wordstat
	head /
		<= List_head $shm_list_head
			title <= title
			filter? <=> filter? \
			Add null
			Close null
			Settings null
	body /
		<= Content $mol_view
			sub /
				<= Stats $mol_view
					sub /
						<= Regular_tasks $shm_ba_summary_card
							title \Ежедневных задач
							value <= regular_tasks \
						<= Regular_items $shm_ba_summary_card
							title \Ежедневных подзадач
							value <= regular_items \
						<= Daily_requests $shm_ba_summary_card
							title \Запросов к Wordstat с начала суток
							value <= daily_requests \
				<= Table $mol_view
					sub /
						<= Table_head $mol_view
							sub /
								<= Head_title $mol_view
									sub / \Название
								<= Head_queries $mol_view
									sub / \Запросы
								<= Head_subtasks $mol_view
									sub / \Кол-во подзадач
								<= Head_date $mol_view
									sub / \Ежедневные данные с даты
								<= Head_daily $mol_view
									sub / \Ежедневный сбор
						<= Rows $mol_list
							rows <= task_rows /
	Task* $mol_view
		sub /
			<= Task_title* $mol_link
				uri <= task_uri* \
				title <= task_title* \
			<= Task_queries* $mol_view
				sub / <= task_queries* \
			<= Task_subtasks* $mol_view
				sub / <= task_subtasks* \
			<= Task_date* $mol_view
				sub / <= task_date* \
			<= Task_daily* $mol_check_box
				title \
				checked? <=> task_daily*? false
	Empty $mol_view
		sub / \Задач нет
